export interface StorageFileServiceProps {
    data: StorageFileProps;
  }
  
export interface StorageFileProps {
    url: string;
}

export enum FileOriginType {
  CUSTOMER_CARE = 0,
  PROTHEUS = 1
}